import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=GOLDEN_EXP_V5:control
// ?preferred_variant=GOLDEN_EXP_V5:variant_1
// ?preferred_variant=GOLDEN_EXP_V5:variant_2

// ?remove_preferred_experiment=GOLDEN_EXP_V5

export const BuyboxGoldenExp = 'GOLDEN_EXP_V5' as const;

export const BuyboxGoldenExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
	VARIANT_2: 'variant_2',
} as const;

export const VARIANTS_DIC: Record<string, string> = {
	control: 'control',
	variant_1: 'v1',
	variant_2: 'v2',
};

export function getGolgenExpTagInformation(variant: string, country: string) {
	const mVariant = VARIANTS_DIC[variant];
	const mCountry = country.toLowerCase();
	const mNumber = '21';
	return {
		variant: mVariant,
		country: mCountry,
		number: mNumber,
	};
}

export type BuyboxGoldenExpVariants = ToVariants<typeof BuyboxGoldenExpVariants>;

export default generate(BuyboxGoldenExp, BuyboxGoldenExpVariants);
